module.exports = __webpack_public_path__ + "static/media/pizza.668399a1.jpg";